import moment from 'moment-timezone'
import _ from 'lodash'

import { AG_GridCustomizedTableHeaders_Key, Notisphere_RecallsFeed_Headers } from '../../../misc/tableHeaders'
import recallsFeedServices from '../../../services/notisphere/recalls-feed'
import recallReviewServices from '../../../services/notisphere/recallReview'
import DetailsTab from '../recall-review/RecallReviewModal/components/DetailsTab.vue'
import FileStatusModal from '../fda/devices/file-status-modal'
import ImportDeviceModal from '../fda/devices/import-device-modal'
export default {
    components: {
        DetailsTab,
        FileStatusModal,
        ImportDeviceModal
    },
    data() {
        return {
            total: 0,
            items: [],
            searchQuery: { pageNumber: 1, pageSize: 500, sort: null, colId: null },
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
                singleClickEdit: true
            },
            gridApi: null,
            columnApi: null,
            delay: 700,
            recall_type: 'device',
            clicks: 0,
            timer: null,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            customDefaultColDef: {
                flex: 1,
                minWidth: 100,
                enableValue: true,
                enableRowGroup: false,
                enablePivot: true,
                sortable: true,
                resizable: true,
                filter: true,
                editable: false,
                wrapText: false,
                autoHeight: false,
                wrapHeaderText: false,
                autoHeaderHeight: false,
                filterParams: {
                    suppressAndOrCondition: true,
                    buttons: ['apply', 'reset'],
                    closeOnApply: true,
                },
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'],
            },
            recallData: null,
            globalSearchText: '',
            lastUpdated: '',
            modalTitle: 'Recall Details',
            modalUdiFieldHeader: [
                {
                    key: 'udi',
                    label: 'UDI'
                },
                {
                    key: 'normalized_udi',
                    label: 'Normalized UDI',
                },
                {
                    key: 'is_valid',
                    label: 'Is Valid'
                },
                {
                    key: 'all_lots',
                    label: 'All Lots'
                },
                {
                    key: 'lots',
                    label: 'Lots'
                },
                {
                    key: 'is_kit',
                    label: 'Is Kit'
                },
                {
                    key: 'is_implantable',
                    label: 'Is Implantable'
                }
            ],
            activeEditingCell: null,
            deviceModalKey: 0,
            fileStatusModalKey: 0
        }
    },
    beforeMount() {
        this.columnDefs = Notisphere_RecallsFeed_Headers
    },
    created() {
        this.rowModelType = 'serverSide'
        //this.fetchMetaData()
    },
    methods: {
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login.RecallsFeed_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        setFilterModel(params) {
            const tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            const filterModel = tableState?.Notisphere_Login?.RecallsFeed_Filters || {}
            params.api.setFilterModel(filterModel)
        },
        applyState(params) {
            const userId = this.$store.state.user.id
            const tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId === userId)[0]
            let columnState = tableState?.Notisphere_Login?.RecallsFeed_Headers
            if (columnState) {
                params.columnApi.applyColumnState({ state: columnState, applyOrder: true })
            }
        },
        onFilterChanged(event) {
            const filterModel = event.api.getFilterModel()
            this.table_Connection_Data.Notisphere_Login.RecallsFeed_Filters = filterModel
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        fetchData(params) {
            let that = this
            this.applyState(params)
            this.setFilterModel(params)
            that.gridApi = params.api
            that.columnApi = params.columnApi
            localStorage.setItem(
                'agGridColumState',
                JSON.stringify(params.columnApi.getColumnState())
            )
            localStorage.setItem(
                'agGridFilterModel',
                JSON.stringify(params.api.getFilterModel())
            )
            const filterModel = that.gridApi.getFilterModel()
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort
            const datasource = {
                getRows(params) {
                    recallsFeedServices.getAllRecallsFeed({
                        search: that.globalSearchText,
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        filterModel
                    }).then((resp) => {
                        if(resp && resp.data) {
                            that.items = resp.data.d.data
                            that.total = resp.data.d.totalCount
                            if(that.total == 0){
                                that.gridApi.showNoRowsOverlay()
                            }
                            else{
                                that.gridApi.hideOverlay()
                            }
                            params.successCallback(resp.data.d.data)
                        } else {
                            params.failCallback()
                            that.total = 0
                        }
                    })
                }
            }
            params.api.setServerSideDatasource(datasource)
        },
        fetchMetaData() {
            recallsFeedServices.getRecallsFeedMetaData().then(resp => {
                if(resp && resp.data) {
                    this.lastUpdated = `${moment(resp.data.data.completed_date).local().format('MM/DD/YY')}`
                } else {
                    this.lastUpdated = ''
                }
            })
        },
        onCellClicked({ colDef, data }) {
            if (colDef.field === 'recall_type') {
                return
            }
            if (colDef && colDef.field === 'recall_link') {
                data.event.preventDefault()
            }
            if( data.source === 'OpenFDA') {
                this.recallData = { ...data }
                this.$nextTick(()=>{
                    this.$refs.recallFdaModal.show()
                })
            } else {
                recallReviewServices.getRecallReviewById(data.source_id).then(resp => {
                    if(resp && resp.data) {
                        this.recallData = { ...resp.data.d.data }
                    }
                    if (this.recallData != null) {
                        this.$nextTick(()=>{
                            this.$refs.recallNotisphereModal.show()
                        })
                    }
                })
            }
        },
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const gridColState = JSON.parse(
                        localStorage.getItem('agGridColumState')
                    )
                    const gridFilterModel = JSON.parse(
                        localStorage.getItem('agGridFilterModel')
                    )
                    const sort = gridColState.filter((s) => s.sort !== null)
                    const email = that.$store.state.user.email
                    const query_param = {
                        pageNumber: that.searchQuery.pageNumber,
                        pageSize: that.searchQuery.pageSize,
                        search_query: that.globalSearchText,
                        sortField: sort.length !== 0 ? sort[0].colId : null,
                        sortDirection: sort.length !== 0 ? sort[0].sort : null,
                        filter_model: gridFilterModel,
                        email: email
                    }
                    const resp = await recallsFeedServices.exportAllRecallsFeed(query_param)
                    that._showOk(resp.data.d.message, {
                        variant: 'success',
                        title: 'Message',
                        buttonTitle: 'Ok',
                    })
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        debounceInput: _.debounce(function (searchStr) {
            this.searchQuery.pageNumber = 1
            if (searchStr.length > 2) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            } else if (searchStr.length === 0) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }, 500),
        onGlobalSearchChange(inputVal) {
            this.globalSearchText = inputVal
            this.debounceInput(inputVal)
        },
        onCellValueChanged(params){
            const payload = {
                id: params.data.id,
                newRecallType: params.newValue !== '(blank)' ? params.newValue : null,
                oldRecallType: params.oldValue,
                userId: this.$store.state.user.id
            }
            recallsFeedServices.updateOpenFDARecallType(payload).then(resp => {
                if(resp.data?.d?.success){
                    this._showToast('Recall Type updated successfully', { variant: 'success' })
                }
            })
        },
        onCellEditingStarted(params) {
            if (params.column.getColId() === 'recall_type') {
                this.activeEditingCell = {
                    rowIndex: params.rowIndex,
                    colKey: params.column.getColId(),
                    api: params.api
                }
                this.$nextTick(() => {
                    document.addEventListener('click', this.onOutsideClick)
                })
            }
        },

        onCellEditingStopped() {
            this.activeEditingCell = null
            document.removeEventListener('click', this.onOutsideClick)
        },

        onOutsideClick(event) {
            const dropdown = document.querySelector('.ag-select')

            if (dropdown && !dropdown.contains(event.target)) {
                if (this.activeEditingCell) {
                    this.activeEditingCell.api.stopEditing()
                }
            }},

        showImportModal() {
            this.deviceModalKey += 1
            this.$nextTick(() => {
                this.$refs.importDeviceModal.forceRerender()
            })
        },

        showFileStatusModal() {
            this.fileStatusModalKey += 1
            this.$nextTick(() => {
                this.$refs.fileStatusModal.forceRerender()
            })
        }
    }
}
